(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-quote-enquiry"] && !Shopify.designMode) return;
  try {
    
function bmInitQuoteForms(root = document) {
  const params = new URLSearchParams(window.location.search);
  root.querySelectorAll('[data-bm-quote]').forEach(section => {
    if (section.dataset.bmReady) return;
    section.dataset.bmReady = 'true';
    const form = section.querySelector('form');
    if (!form) return;
    const setValue = (selector, value) => {
      const field = form.querySelector(selector);
      if (field && !field.value && value) field.value = String(value).slice(0, field.maxLength > 0 ? field.maxLength : 500);
    };
    setValue('[data-bm-product]', params.get('product_name'));
    const reference = params.get('product_id');
    if (reference && /^\d+$/.test(reference)) setValue('[data-bm-reference]', reference);
    setValue('[data-bm-colour]', params.get('colour'));
    const choices = [];
    for (let i = 1; i <= 3; i++) {
      const name = (params.get('option_name_' + i) || '').slice(0, 100);
      const value = (params.get('option_' + i) || '').slice(0, 200);
      if (!name || !value) continue;
      if (/^colou?r$/i.test(name)) setValue('[data-bm-colour]', value);
      else choices.push(name + ': ' + value);
    }
    setValue('[data-bm-options]', choices.join('\n'));
    const quantity = params.get('quantity');
    if (quantity && /^\d+$/.test(quantity) && Number(quantity) > 0) setValue('[data-bm-quantity]', quantity);
    const handle = params.get('product_handle');
    if (handle && /^[a-z0-9-]+$/.test(handle)) setValue('[data-bm-url]', window.location.origin + '/products/' + handle);
    const date = form.querySelector('[data-bm-date]');
    if (date) {
      const now = new Date();
      const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      date.min = localDate;
    }
    const preview = params.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) {
      const action = new URL(form.action, window.location.origin);
      action.searchParams.set('preview_theme_id', preview);
      form.action = action.href;
    }
    const success = section.querySelector('.bm-quote-success');
    if (success) success.focus();
  });
}
bmInitQuoteForms();
document.addEventListener('shopify:section:load', event => bmInitQuoteForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-bm-video-hero]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const video = root.querySelector('video');
        const toggle = root.querySelector('button');
        if (!video || !toggle) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let visible = false;
        let manualPause = false;
        let requestedPlay = false;
        const allowed = () => requestedPlay || (!reduced.matches && !navigator.connection?.saveData);
        const update = () => { toggle.textContent = video.paused ? toggle.dataset.play : toggle.dataset.pause; };
        const play = () => {
          if (!visible || document.hidden || manualPause || !allowed()) return;
          if (!video.getAttribute('src')) { video.src = video.dataset.src; video.load(); }
          video.muted = true;
          video.play().catch(update);
        };
        toggle.hidden = false;
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        toggle.addEventListener('click', () => {
          if (video.paused) { requestedPlay = true; manualPause = false; play(); }
          else { manualPause = true; video.pause(); }
        });
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible) play(); else video.pause();
        }, { threshold: .15 });
        observer.observe(root);
        document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
        reduced.addEventListener('change', () => {
          requestedPlay = false;
          if (reduced.matches) video.pause(); else play();
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
